import React, { Fragment } from "react";
import OtherHelp from "./OtherHelp";

const DiseaseFundWaitListOnlyCard = ({ data }) => {
  return (
    <div className="FundClosedCard Card bg-coral-light-50">
      <div className="Card-inner">
        <div className="Card-inner-content">
          <div className="f-scale-body">
            <Fragment>
              <p className="f-h3">Check Back Later</p>
              <p className="u-mt1 u-mb2">
                Please check back soon to see if the fund is open or to sign up for the wait list.
              </p>
              <hr className="Card-hr u-mt4 u-mb4" />
            </Fragment>

            <OtherHelp data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiseaseFundWaitListOnlyCard;
